import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import implantImg from '../media/implant.png'
import implant2Img from '../media/implant2.jpeg'
import {useTranslation, Trans} from 'react-i18next'

export default function Implant() {
    const { t } = useTranslation();
    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {implantImg}
            title = {t('treatSectionImplant')}
            paragraph = "Ofrecemos implantes dentales con los mejores materiales y profesionales"
            addClass = "min-width" 
            mediaContent = 
            {
            `# ${t('treatSectionImplant')}
***  

${t('implantParaf')}


![](${implant2Img})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
